/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {Color, IconProps, IconSize} from '../types/types';
import useIconDLS from './useIconDLS';

/**
 * Defines the Design Language System (DLS) Material Filled Forward Icon component.
 */
export const MaterialFilledForwardIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
      <path d='M10 17l5-5-5-5v10z' fill={iconColor}
        fillRule='evenodd'
        clipRule='evenodd' />
    </svg>
  );
};
MaterialFilledForwardIcon.defaultProps = {
  size  : IconSize.large,
  color : Color.grey1
};
export default MaterialFilledForwardIcon;
